import CsrToolBar from "@/components/create-certificate/create-certificate-tool-bar.vue";
import TooltipComponent from "@/components/global/tooltip-component.vue";
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import GlobalCancelPopup from "@/components/global/global-cancel-popup.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import CreateCertificatePopups from "@/components/create-certificate/msg/create-certificate-popups.vue";
import CreateCertificateCsrContent from "@/components/create-certificate/csr-content/create-certificate-csr-content.vue";
import GlobalRadioGroup from "@/components/global/global-radio-group.vue";
import pgwyClient from "@/api/pgwyClient";
import { mapActions } from "vuex";
import * as constants from "@/config/constants";
import Moment from "moment";

export default {
  components: {
    CsrToolBar,
    TooltipComponent,
    GlobalMsgAlert,
    GlobalCancelPopup,
    GlobalDetailsPopup,
    CreateCertificatePopups,
    CreateCertificateCsrContent,
    GlobalRadioGroup
  },
  data() {
    return {
      event: "",
      uploadError: false,
      showSuccess: false,
      showError: false,
      errorMsg: "",
      successMsg: "",
      radioGroup: "",
      radioGroup2: "limited",
      showText: false,
      isSubmitting: false,
      fileContent: null,
      showUploadMethod: false,
      showCopyAndPasteMethod: false,
      fileContentRules: [(v) => !!v || "CSR content is required"],
      procedureRules: [(v) => !!v || "Select a procedure"],
      downloadRules: [(v) => !!v || "Select a format"],
      timeRules: [
        (v) => !!v || "Required",
        (v) => (v && v.length >= 5 && v.length <= 5) || "enter time as hh:mm",
      ],
      allProcedures: null,
      selectedProcedure: null,
      download: false,
      minDate: new Date().toISOString().slice(0, 10),
      validFromDateModel: null,
      validToDateModel: null,
      certId: null,
      isReadOnly: false,
      isUploadOnly: "Upload a pkcs10 file",
      file: "",
      dragging: false,
      cancelSubmit: false,
      cancelDeleteDialog: false,
      cancelDeleteCSRDialog: false,
      doneUpload: false,
      limited: true,
      startTimeStamp: "",
      endTimeStamp: "",
      enabledStart: false,
      enabledEnd: false,
      // certificate id from response of CSR
      selectedFormatIndex: null,
      valid: true,
      fileErrorText: "",
      fileErrorSubText: "",
      invalidFile: false,
    };
  },
  watch: {
    showTablesSwitch() {
      setTimeout(() => {
        this.injectFromToTextsToTable();
      }, 10);
    },
  },
  computed: {
    isButtonDisabled() {
      return this.selectedProcedure === null;
    },
    procedureValidity() {
      if (this.selectedProcedure) {
        const procedure = this.allProcedures.find((proc) => proc.procid === this.selectedProcedure);
        const certProcedures = procedure?.certificateprocedures;
        if (certProcedures?.length) {
          const validityString = certProcedures[0].validity;
          if (validityString) {
            const validity = Moment.duration(validityString);
            if (validity.isValid()) {
              return validity.humanize();
            }
          }
        }
      }
      return "unspecified";
    },
    constants() {
      return constants;
    },
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
    // v-btn size
    size() {
      const size = {
        xs: "small",
        sm: "small",
        lg: "medium",
        xl: "large",
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    // Date picker width
    pickerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "230";
        case "sm":
          return "300";
      }
    },
  },
  mounted() {
    this.getProcedures();
  },
  methods: {
    ...mapActions(["updateCertificates", "updateProcedures"]),
    cancelDeleteDialogButton() {
      this.cancelDeleteCSRDialog = false;
    },
    filterNumbers: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^\d{0,4}(-\d{0,2}(-\d{0,2})?)?$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    doShowText() {
      this.showText = true;
    },
    dontShowText() {
      this.showText = false;
    },
    fullLengthValidity() {
      this.limited = false;
      this.validToDateModel = "";
      this.validFromDateModel = "";
    },
    limitedValidity() {
      this.limited = true;
    },
    deleteButton() {
      this.cancelDeleteDialog = false;
      this.cancelDeleteCSRDialog = true;
      this.showText = false;
    },
    cancelSubmitCSR() {
      this.cancelSubmit = false;
    },
    cancelClicked() {
      this.cancelSubmit = true;
    },
    removeFile() {
      this.file = "";
      this.cancelDeleteCSRDialog = false;
      this.fileContent = "";
      this.doneUpload = false;
      this.download = false;
      this.isSubmitting = false;
      this.fileErrorText = "";
      this.fileErrorSubText = "";
      this.invalidFile = false;
    },

    getProcedures() {
      this.updateProcedures()
        .then((procedures) => {
          this.allProcedures = procedures.filter((procedure) =>
            !procedure.protocol);
        })
        .catch((error) => {
          this.errorMsg = error.response?.data?.msg || "Failed to fetch procedures";
          this.showError = true;
        });
    },
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.cancelDeleteDialog = false;
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    getFileExtension(filename) {
      return filename.split(".").pop();
    },
    createFile(file) {
      if (file.size > 5000) {
        this.invalidFile = true;
        this.fileErrorText = "Maximum File Size Exceeded";
        this.fileErrorSubText = "File size limit: 5kb";
        this.dragging = false;
        this.cancelDeleteDialog = false;
        return;
      }

      if (file.size <= 0) {
        this.invalidFile = true;
        this.fileErrorText = "File is empty";
        this.fileErrorSubText = "Please make sure that file has valid CSR content";
        this.dragging = false;
        this.cancelDeleteDialog = false;
        return;
      }

      this.file = file;
      if (file) {
        this.loadFile(file).then(() => {
          if (this.fileContent) {
            this.fileContent = this.fileContent.trim();
          }
          if (this.fileContent === "") {
            this.invalidFile = true;
            this.fileErrorText = "File is not valid";
            this.fileErrorSubText = "Please make sure that file has valid CSR content";
            this.dragging = false;
            this.cancelDeleteDialog = false;
            return;
          } else {
            this.injectFromToTextsToTable();
            this.cancelDeleteDialog = true;
            this.successMsg = "File uploaded successfully";
            this.showSuccess = true;
          }
        });
      }
      this.dragging = false;
      this.showText = true;
    },
    uploadMethod() {
      this.showCopyAndPasteMethod = false;
      this.showUploadMethod = true;
      this.showText = false;
      this.removeCurrentContent();
      this.isUploadOnly = "Upload a PKCS10 file...";
      this.isReadOnly = true;
    },
    copyAndPasteMethod() {
      this.showCopyAndPasteMethod = true;
      this.showUploadMethod = false;
      this.showText = true;
      this.isUploadOnly = "Paste CSR content here...";
      this.isReadOnly = false;
      this.removeFile();
      this.removeCurrentContent();
      this.cancelDeleteDialog = false;
    },
    addMinutes(date, minutes) {
      date.setMinutes(date.getMinutes() + minutes);
      return date;
    },
    uploadCsrFileClicked() {
      const d = new Date();
      const a = d.toISOString();
      const e = a.slice(10, 25);

      if (this.showText == true) this.valid = this.$refs.form.validate();
      this.valid = this.$refs.select.validate();

      if (this.valid) {
        this.isSubmitting = true;
        const params = {};
        if (this.validFromDateModel && !this.startTimeStamp) {
          const noStartTimeGiven = new Date(this.validFromDateModel + e);
          const noGivenTime = this.addMinutes(noStartTimeGiven, 1);
          params.validFrom = noGivenTime.toISOString();
        } else if (this.validFromDateModel && this.startTimeStamp) {
          const startTime = new Date(
            this.validFromDateModel + " " + this.startTimeStamp
          ).toISOString();
          params.validFrom = startTime;
        }
        if (this.validToDateModel && !this.endTimeStamp) {
          const noEndTimeGiven = new Date(this.validToDateModel + a.slice(10, 25));
          params.validTo = noEndTimeGiven.toISOString();
        } else if (this.validToDateModel && this.endTimeStamp) {
          const endTime = new Date(
            this.validToDateModel + " " + this.endTimeStamp
          ).toISOString();
          params.validTo = endTime;
        }

        pgwyClient.createPkcs10Certificate(this.fileContent, this.selectedProcedure, params)
          .then(async (res) => {
            this.certId = res.headers.certid;
            this.download = true;
            this.showText = false;
            this.errorMsg = null;
            this.isSubmitting = false;
            this.doneUpload = true;
            this.showSuccess = true;
            this.successMsg = "Certificate request successfully submitted";
            await this.updateCertificates();
          })
          .catch((error) => {
            this.download = false;
            this.isSubmitting = false;
            if (error.response?.data?.error) {
              this.errorMsg = error.response.data.msg;
              this.showError = true;
            } else if (error.response?.data?.status === "notsigned") {
              this.uploadError = false;
              this.showError = false;
            } else {
              if (!this.fileContent) {
                this.uploadError = true;
              } else this.showError = true;
            }
          });
      }
    },
    async downloadCertificateClicked({ certid, type, extension }) {
      await pgwyClient.downloadCertificates([certid], type, extension);
    },
    loadFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileName = file.name;
          const temFileContent = e.target.result;

          if (this.isCsrDerEncoded(temFileContent)) {
            this.fileContent = this.convertToPemFormat(temFileContent);
            resolve();
          } else if (this.isCsrPemEncoded(temFileContent)) {
            this.fileContent = temFileContent
              .split(/\r?\n/)
              .filter((line) => line.trim() !== "")
              .join("\n");
            resolve();
          } else {
            reject();
          }
        };
        reader.readAsBinaryString(file);

      }).catch(() => {
        this.invalidFile = true;
        this.fileErrorText = "File is not valid";
        this.fileErrorSubText = "Please make sure that file has valid CSR content";
        this.download = false;
        this.errorMsg = "CSR file is not valid";
        this.showError = true;
      });
    },
    // Check ASN.1 encoding and length of the first CertificationRequest SEQUENCE
    isCsrDerEncoded(fileContent) {
      return this.getAsn1FieldTag(fileContent) == 0x30 &&
        fileContent.length == this.getAsn1FieldLength(fileContent);
    },
    isCsrPemEncoded(fileContent) {
      const inputContent = fileContent.trim();
      try {
        const csrContent = this.getPemCsrContent(inputContent);
        return csrContent.length == this.getAsn1FieldLength(csrContent);
      } catch (ex) {
        return false;
      }
    },
    getPemCsrContent(inputContent) {
      if (inputContent.startsWith(constants.CSR_PEM_HEADER)
        && inputContent.endsWith(constants.CSR_PEM_FOOTER)
        && inputContent.length > constants.CSR_PEM_HEADER.length + constants.CSR_PEM_FOOTER.length) {

        const csrStart = constants.CSR_PEM_HEADER.length;
        const csrEnd = inputContent.length - constants.CSR_PEM_FOOTER.length;
        return atob(inputContent.substring(csrStart, csrEnd).replace(/[\r\n]+/, ""));
      }
      else if (inputContent.startsWith(constants.CSR_PEM_ALT_HEADER)
        && inputContent.endsWith(constants.CSR_PEM_ALT_FOOTER)
        && inputContent.length > constants.CSR_PEM_ALT_HEADER.length + constants.CSR_PEM_ALT_FOOTER.length) {

        const csrAltStart = constants.CSR_PEM_ALT_HEADER.length;
        const csrAltEnd = inputContent.length - constants.CSR_PEM_ALT_FOOTER.length;
        return atob(inputContent.substring(csrAltStart, csrAltEnd).replace(/[\r\n]+/, ""));
      }
      else {
        throw new Error("Invalid PEM content!");
      }
    },
    getAsn1FieldTag(field) {
      return field.charCodeAt(0);
    },
    getAsn1FieldLength(field) {
      if (field.length >= 2) {
        return 1 + this.getAsn1LengthFieldSize(field) + this.getAsn1LengthField(field);
      } else {
        return 0;
      }
    },
    getAsn1LengthFieldSize(field) {
      return (field.charCodeAt(1) & 0x80) ? 1 + (field.charCodeAt(1) & 0x7f) : 1;
    },
    getAsn1LengthField(field) {
      if (field.charCodeAt(1) & 0x80) {
        const longFormBytes = field.charCodeAt(1) & 0x7f;

        if (field.length < 4) {
          return 0;
        } else {
          var val = 0;
          for (var i = 0; i < longFormBytes; i++) {
            val |= field.charCodeAt(i + 2) << (8 * (longFormBytes - i - 1));
          }
          return val;
        }
      } else {
        return field.charCodeAt(1);
      }
    },
    convertToPemFormat(x509data) {
      return constants.CSR_PEM_HEADER + constants.CSR_PEM_NEWLINE
        + btoa(x509data).match(/.{1,64}/g).join(constants.CSR_PEM_NEWLINE)
        + constants.CSR_PEM_NEWLINE + constants.CSR_PEM_FOOTER + constants.CSR_PEM_NEWLINE;
    },
    uploadFileClicked() {
      this.$refs.uploader.click();
    },
    injectFromToTextsToTable() {
      const datePickersTitle = document.getElementsByClassName(
        "v-date-picker-title__year"
      );
      Object.keys(datePickersTitle).forEach((key) => {
        datePickersTitle[key].style.display = "flex";
        datePickersTitle[key].style.justifyContent = "space-between";
        const text = key === "0" ? "Valid From" : "Valid To";
        datePickersTitle[key].insertAdjacentHTML(
          "beforeend",
          '<div style="color:white">' + text + "</div>"
        );
      });
    },
    removeCurrentContent() {
      this.fileContent = null;
      this.fileName = "";
      this.download = false;
      this.certId = null;
      this.valid = true;
    },
  },
};